var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessengerIconGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_423_2139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.00012 18.1111L4.15568 14.6444C3.15696 13.1673 2.79567 11.4181 3.13898 9.72201C3.48229 8.02591 4.50684 6.49834 6.02214 5.42332C7.53743 4.3483 9.44035 3.79898 11.3771 3.87751C13.3138 3.95604 15.1526 4.65706 16.5515 5.85024C17.9504 7.04342 18.8142 8.64755 18.9824 10.3644C19.1506 12.0812 18.6116 13.7939 17.4658 15.1841C16.3199 16.5742 14.6452 17.5472 12.7528 17.9221C10.8605 18.2969 8.87941 18.0482 7.1779 17.2222L3.00012 18.1111",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4447 11.8891L10.1114 10.1113L11.8891 11.8891L14.5558 10.1113",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_423_2139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "white",
    transform: "translate(0.333496 0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerIconGray);
export default __webpack_public_path__ + "static/media/messengerIconGray.d65913ac01ebd85a3621b37beb7fe868.svg";
export { ForwardRef as ReactComponent };